"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrendingTags = TrendingTags;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tag = require("./Tag");
var _classnames = _interopRequireDefault(require("classnames"));
function TrendingTags({
  tags,
  isCenterAligned,
  dataCyWrapper = 'trending-tld-tags-wrapper',
  dataCyTag,
  classNameTag,
  classNameWrapper
}) {
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": dataCyWrapper,
    "data-testid": dataCyWrapper,
    className: classNameWrapper || (0, _classnames.default)('mb-2 ms-2 d-flex', {
      'justify-content-center': isCenterAligned
    })
  }, tags.map(({
    text,
    textValues,
    color
  }, index) => text && /*#__PURE__*/_react.default.createElement(_Tag.Tag, {
    key: index,
    textId: text,
    textValues: textValues,
    color: color,
    dataCy: dataCyTag || 'trending-tld-tag',
    className: classNameTag
  })));
}
TrendingTags.propTypes = {
  tags: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    textValues: _propTypes.default.object,
    color: _propTypes.default.string
  })),
  isCenterAligned: _propTypes.default.bool,
  dataCyWrapper: _propTypes.default.string,
  dataCyTag: _propTypes.default.string,
  classNameTag: _propTypes.default.string,
  classNameWrapper: _propTypes.default.string
};